
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emprestimo-garantia-carro-app",
      function () {
        return require("private-next-pages/emprestimo-garantia-carro-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emprestimo-garantia-carro-app"])
      });
    }
  